export enum Feature {
  CanCaptureDpm = 1
}

export enum AccessLevel {
  Allow = 1,
  Deny = 2
}
